import type { Injection } from '../../../types/utils';
import type { DescriptionListInjection } from './DescriptionList.types';

export const DESCRIPTION_LIST_INJECTION: Injection<DescriptionListInjection> = {
  key: Symbol('DATA_VIEW_SORTING_INJECTION_KEY'),
};
